<template>
  <div>
    <div class="w-100 px-5 py-4">
      <div slot="title">
        <h1>{{sesionDeLaAudiencia.Audiencia != undefined && sesionDeLaAudiencia.Audiencia != null ? sesionDeLaAudiencia.Audiencia.TipoDocumento.Nombre : "Cargando sesión de la audiencia"}} {{sesionDeLaAudiencia.Audiencia != undefined ? sesionDeLaAudiencia.Audiencia.Consecutivo : ""}}</h1>
        <div class="d-flex">
          <h3>{{grabacionEnProceso ? "Grabando" : "Preparado para grabar"}} en la sala {{sesionDeLaAudiencia.Sala != undefined && sesionDeLaAudiencia.Sala != null ? sesionDeLaAudiencia.Sala.Nombre : ""}}</h3>&nbsp;
          <div :class="cargaElInicioDeLaGrabacion()"></div>
        </div>
      </div>
      <div class="row d-flex">
        <div class="col-12 col-sm-12 col-md-12 col-lg-3 padding-div-low">
          <div v-if="grabacionEnProceso">
            <div class="area">
              <h3>Seleccione un marcador</h3>
              <hr />
              <div class="form-group flex-wrap">
                <C005TiposMarcador v-on:valorParaElPadre="marcaElTipoDeMarcador" :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" :idDelInput="'grabacion_TiposMarcador'" :valorDefinido="marcador.TipoMarcador.TipoMarcadorId" :parametros="{}"></C005TiposMarcador>
              </div>
              <div v-if="marcador.TipoMarcador.TipoMarcadorId == 99 || marcador.TipoMarcador.TipoMarcadorId == 94" class="form-group flex-wrap">
                <label for="grabacion_Comentarios" class="mb-2">Comentarios</label>
                <textarea class="form-control" id="grabacion_Comentarios" v-model="marcador.Comentarios" rows="3"></textarea>
              </div>
              <div v-if="marcador.TipoMarcador.TipoMarcadorId == 94" class="form-group">
                <label for="grabacion_Receso">Receso</label>
                <input type="text" id="grabacion_Receso" class="form-control" v-model="marcador.DuracionDelReceso" v-mask="'##:##'" placeholder="hh:mm">
              </div>
              <div class="justify-content-end text-right">
                <button class="btn btn-primary" v-on:click="guardarMarcador()">Agregar marcador</button>
              </div>
            </div>
            <br />
            <div class="area marcadores">
              <h3>Marcadores</h3>
              <hr />
              <ul class="form-group list-group">
                <li v-for="marcador in sesionDeLaAudiencia.Marcadores" class="list-group-item">
                  <h6 v-html="obtenElTiempoDelMarcadorConFormato(marcador.Tiempo, true)"></h6>
                  <span>{{marcador.TipoMarcador.Nombre}}<br v-if="marcador.TipoMarcador.TipoMarcadorId == 94" />{{marcador.TipoMarcador.TipoMarcadorId == 94 ? obtenElTiempoDelMarcadorConFormato(marcador.DuracionDelReceso, false) : ""}}</span>
                  <br />
                  <span v-if="marcador.TipoMarcador.TipoMarcadorId == 99 || marcador.TipoMarcador.TipoMarcadorId == 94">Observaciones: {{marcador.Comentarios}}</span>
                </li>
              </ul>
            </div>
          </div>
          <div v-if="!grabacionEnProceso" class="area">
            <h2>Grabación</h2>
            <hr />
            <h6 v-if="!grabacionFinalizada" class="text-justify">La sala esta preparada para iniciar la sesión.<br /><br />Una vez que sea anunciada el inicio de la sesión, presione "Iniciar grabación", para empezar a grabar la audiencia.</h6>
            <h6 v-else class="text-justify">La sesión ha sido finalizada correctamente.</h6>
            <br />
            <div class="justify-content-end text-right">
              <button v-if="!grabacionFinalizada || sesionDeLaAudiencia != {}" class="btn btn-primary mb-2" v-on:click="ejecutarGrabacionDeCamaras()">
                <i class="fas fa-video"></i>&nbsp;&nbsp;Iniciar grabación
              </button>
              <button v-if="!grabacionFinalizada" class="btn btn-danger mb-2" v-on:click="cancelarLaGrabacion()">
                <i class="fas fa-times"></i>&nbsp;&nbsp;Salir de la grabación
              </button>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-9 padding-div-low">
          <div class="area">
            <div class="d-flex justify-content-between">
              <div>
                <h4>Sala {{sesionDeLaAudiencia.Sala != undefined && sesionDeLaAudiencia.Sala != null ? sesionDeLaAudiencia.Sala.Nombre : ""}}</h4>
                <h6>{{grabacionEnProceso ? "Grabando audiencia" : "Preparado para grabar la audiencia"}}</h6>
              </div>
              <div>
                <h1>{{tiempo.Horas}}:{{tiempo.Minutos}}.{{tiempo.Segundos}}</h1>
              </div>
            </div>
            <hr />
            <Reproductor v-if="sesionDeLaAudiencia.Sala != undefined" :parametros="sesionDeLaAudiencia"></Reproductor>
            <hr v-if="sesionDeLaAudiencia.Sala != undefined"/>
            <div v-if="sesionDeLaAudiencia.Sala != undefined" class="justify-content-end text-right">
              <button v-if="grabacionEnProceso" class="btn btn-danger mb-2" v-on:click="cambiarSala()">
                <i class="fas fa-exchange-alt"></i>&nbsp;&nbsp;Cambiar de sala
              </button>
              <button v-if="grabacionEnProceso" class="btn btn-success mb-2" v-on:click="finalizarGrabacion()">
                <i class="fas fa-check"></i>&nbsp;&nbsp;Finalizar la grabación
              </button>
              <button v-if="grabacionEnProceso" class="btn btn-success mb-2" v-on:click="EjecutarCambioEnLaAudiencia()">
                <i class="fas fa-check"></i>&nbsp;&nbsp;Realizar cambio a las cámaras 
              </button>
              <button v-if="falloLaGeneracionDelZip" class="btn btn-success mb-2" v-on:click="generarTokenYCrearZIP()">
                <i class="fas fa-file-archive"></i>&nbsp;&nbsp;Crear el ZIP de la audiencia
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <audio ref="audio_forseti" :src='audioSource' type="audio/mp3" :controls='false' ></audio>
  </div>
</template>

<script>
  import sistemas from '@/../static/js/sistemas';
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import router from '@/router/index'
  import axios from 'axios'
  import VueMask from 'v-mask'

  Vue.use(VueMask);

  export default {
    components: {
      enumeraciones,
      Reproductor: sistemas.Forseti.Reproductor,
      C005TiposMarcador: catalogos.Forseti.C005TiposMarcador
    },
    data() {
      return {
        enumeraciones,
        sesionDeLaAudiencia: {},
        grabacionEnProceso: false,
        grabacionFinalizada: false,
        falloLaGeneracionDelZip: false,
        marcador: {
          TipoMarcador: {
            TipoMarcadorId: -1
          },
          Comentarios: null,
          DuracionDelReceso: null,
          Tiempo: null
        },
        tiempo: {
          Horas: "00",
          Minutos: "00",
          Segundos: "00"
        },
        actualizarTiempoDeGrabacion: null,
        audioSource:null
      }
    },
    props: {
      SesionDeLaAudienciaId: Number,
      AudienciaId: Number
    },
    mounted() {
      this.obtenSesionDeLaAudienciaAGrabar();
    },
    methods: {
      cargaElInicioDeLaGrabacion: function () {
        return "grabador " + (this.grabacionEnProceso ? "grabando" : "sin-grabar");
      },
      obtenElTiempoDelMarcadorConFormato: function(tiempo, conSegundos) {
        const formatoDeTiempo = tiempo.split(":");
        return "Tiempo: " + formatoDeTiempo[0] + ":" + formatoDeTiempo[1] + (conSegundos ? "." + formatoDeTiempo[2] : "");
      },
      obtenSesionDeLaAudienciaAGrabar: function() {
        comun.SeEstaCargandoInformacion(true);
        const parametros = {
          SesionDeLaAudienciaId: this.SesionDeLaAudienciaId,
          EsPrueba: this.enumeraciones.EsPrueba
        };

        axios.post(
          api.conexion + api.Forseti.sistema.audiencias.audienciaspendientes.ObtenSesionDeLaAudienciaPendiente,
          parametros,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
          ).then(respuesta => {
            if(respuesta.data.SiHayError){
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
              this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
            } else {
              //this.parametrosDeSala.AreaId = respuesta.data.SesionDeLaAudienciaPendiente.Audiencia.Area.AreaId; Por si es necesario cargar las salas en base al area
              this.sesionDeLaAudiencia = respuesta.data.SesionDeLaAudienciaPendiente;
              this.grabacionEnProceso = this.sesionDeLaAudiencia.TipoEstatusDeAudiencia.TipoEstatusDeAudienciaId == 3 ? true : false;
              this.EjecutaTransmisionAudio();
              setTimeout(()=>{
                const audio_audiencia = this.$refs.audio_forseti;
                audio_audiencia.src = this.sesionDeLaAudiencia.Sala.IPDeTransmision;
                audio_audiencia.preload= "none";
                audio_audiencia.play();
              }, 1500);

              if(this.grabacionEnProceso)
                
                this.cargaLaGrabacion();

            }
            comun.SeEstaCargandoInformacion(false);
          }
          ).catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
            comun.SeEstaCargandoInformacion(false);
          });
      },
      cancelarLaGrabacion: function() {
        let _this= this;
        bootbox.confirm({
          title: "Mensaje del sistema",
          message: "¿Salir de la grabación de la audiencia?",
          buttons: {
            cancel: {
              label: '<i class="fa fa-times"></i>&nbsp;&nbsp;No'
            },
            confirm: {
              label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Si'
            }
          },
          callback: function (respuesta) {
            if (respuesta) {
              _this.EjecutaFinalizarTransmisionAudio(_this.sesionDeLaAudiencia);
              _this.EjecutaFinalizarTransmisionEvidenciador();
              router.push({ name: "PanelDeAudienciasPendientes" });
            }
          }
        });
      },
      ejecutarGrabacionDeCamaras: function () {
        comun.SeEstaCargandoInformacion(true);        
        const parametros = {
          rutaDeVideo: this.sesionDeLaAudiencia.RutasDeVideos[0],
          camaras: this.sesionDeLaAudiencia.Camaras,
          EsPrueba: false
        }
        axios.post(
          'http://' + this.sesionDeLaAudiencia.Sala.IP + this.sesionDeLaAudiencia.Sala.PuertoDeGrabacion + api.Forseti.sistema.audiencias.audienciaspendientes.EjecutarGrabacionDeSala,
          parametros,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
          ).then(respuesta => {
            if (respuesta.data.Error != undefined) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error, null, null);
              comun.SeEstaCargandoInformacion(false);
            } else {
              this.iniciarGrabacion(respuesta.data);
            }
          }
          ).catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
            comun.SeEstaCargandoInformacion(false);
          });
      },
      iniciarGrabacion: function(fechaDeInicio) {
        comun.SeEstaCargandoInformacion(true);
        const parametros = {
          SesionDeLaAudienciaId: this.SesionDeLaAudienciaId,
          FechaDeInicio: fechaDeInicio,
          EsPrueba: this.enumeraciones.EsPrueba
        };

        axios.post(
          api.conexion + api.Forseti.sistema.audiencias.audienciaspendientes.IniciarSesionDeLaAudiencia,
          parametros,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
          ).then(respuesta => {
            if(respuesta.data.SiHayError){
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
              this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
            } else {
              this.grabacionEnProceso = true;
              this.sesionDeLaAudiencia.FechaDeInicio = fechaDeInicio;
              this.cargaLaGrabacion();
              
            }
            comun.SeEstaCargandoInformacion(false);
          }
          ).catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
            comun.SeEstaCargandoInformacion(false);
          });
      },
      cargaLaGrabacion: function () {
        let fechaDeInicioDeLaGrabacion = moment(this.sesionDeLaAudiencia.FechaDeInicio);
        let fechaDeAhorita = moment();
        
        let diferencia = moment.duration(fechaDeAhorita.diff(fechaDeInicioDeLaGrabacion));
        this.tiempo.Horas = this.verificarElTiempoDesplegado((diferencia._data.hours + (diferencia._data.days * 24)));
        this.tiempo.Minutos = this.verificarElTiempoDesplegado(diferencia._data.minutes);
        this.tiempo.Segundos = this.verificarElTiempoDesplegado(diferencia._data.seconds);
        //se inicia conteo de grabacion un segundo despues
        setTimeout(()=>{
          this.revisarTiempoDeGrabacion();
        }, 1000)
      },
      revisarTiempoDeGrabacion: function() {
        let segundos = parseInt(this.tiempo.Segundos);
        let minutos = parseInt(this.tiempo.Minutos);
        let horas = parseInt(this.tiempo.Horas);

        segundos++;
        if (segundos >= 60) {
            segundos = 0;
            minutos++;
            if (minutos >= 60) {
                minutos = 0;
                horas++;
            }
        }

        this.tiempo.Horas = this.verificarElTiempoDesplegado(horas);
        this.tiempo.Minutos = this.verificarElTiempoDesplegado(minutos);
        this.tiempo.Segundos = this.verificarElTiempoDesplegado(segundos);

        this.actualizarTiempoDeGrabacion = setTimeout(() => {
          this.revisarTiempoDeGrabacion();
        }, 1000);
      },
      verificarElTiempoDesplegado: function(tiempo) {
        if(parseInt(tiempo) < 10)
          tiempo = "0" + tiempo;

        return tiempo;
      },
      marcaElTipoDeMarcador: function(datos) { 
        this.marcador.TipoMarcador = {
          TipoMarcadorId: parseInt(datos.TipoMarcadorId),
          Nombre: datos.Nombre
        }
      },
      validarMarcadorAAgregar: function() {
        if(this.marcador.TipoMarcador.TipoMarcadorId == undefined || this.marcador.TipoMarcador.TipoMarcadorId <= 0) {
          comun.mensajeDeAlerta("Seleccione el tipo de marcador para poder guardarlo.", null, null);
          return false;
        }

        if(this.marcador.TipoMarcador.TipoMarcadorId == 99 || this.marcador.TipoMarcador.TipoMarcadorId == 94) {
          if(this.marcador.Comentarios == "") {
            comun.mensajeDeAlerta("Ingrese las observaciones.", null, null);
            return false;
          }

          if(this.marcador.TipoMarcador.TipoMarcadorId == 94) {
            if(!moment(this.marcador.DuracionDelReceso, "HH:mm A").isValid()) {
              comun.mensajeDeAlerta("Ingrese el tiempo de receso.", null, null);
              return false;
            }
          }
        }

        return true;
      },
      ejecutaLaFinalizacionDeLaGrabacion: async function() {
        return axios.post(
          'http://' + this.sesionDeLaAudiencia.Sala.IP + this.sesionDeLaAudiencia.Sala.PuertoDeGrabacion + api.Forseti.sistema.audiencias.audienciaspendientes.EjecutarFinalizacionDeGrabacionDeSala,
          {"Ruta": this.sesionDeLaAudiencia.RutasDeVideos[0].Ruta }, //Agregado para enviar ruta en caso que la grabacion cerrara y quedara en estatus de Sesion origina {}
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
          ).then(respuesta => {
            if (respuesta.Error != undefined) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.Error, null, null);
              throw respuesta
            } else {
              return respuesta;
            }
          }
          ).catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
            comun.SeEstaCargandoInformacion(false);
          });
      },
      guardarMarcador: function() { 
        if(this.validarMarcadorAAgregar()) {
          this.marcador.Tiempo = this.tiempo.Horas + ":" + this.tiempo.Minutos + ":" + this.tiempo.Segundos;
          const parametros = {
            SesionDeLaAudienciaId: this.SesionDeLaAudienciaId,
            Marcador: this.marcador
          };

          if(this.marcador.TipoMarcador.TipoMarcadorId == 94) {
            bootbox.confirm({
              title: "Mensaje del sistema",
              message: "La audiencia entraría a receso y se generaría una nueva sesión. <br />¿Desea continuar?",
              buttons: {
                cancel: {
                  label: '<i class="fa fa-times"></i>&nbsp;&nbsp;No'
                },
                confirm: {
                  label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Si, iniciar receso'
                }
              },
              callback: async (respuestaDelBootBox) => {
                if(respuestaDelBootBox) {
                  await this.ejecutaLaFinalizacionDeLaGrabacion()
                    .then(respuesta => {
                      //parametros.FechaDeFinalizacion = respuesta.data

                      this.realizarGuardadoDeMarcador(parametros);
                    })
                    .catch(exception => { console.log(exception) });
                }
              }
            });
          } else {
            this.realizarGuardadoDeMarcador(parametros);
          }
        }
      },
      realizarGuardadoDeMarcador: function (parametros) {
        comun.SeEstaCargandoInformacion(true);

        axios.post(
            api.conexion + api.Forseti.sistema.audiencias.audienciaspendientes.GuardarMarcador,
            parametros,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
            ).then(respuesta => {
              if(respuesta.data.SiHayError){
                console.log(respuesta);
                comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
              } else {
                if(this.marcador.TipoMarcador.TipoMarcadorId == 94) {
                  this.limpiarParaFinalizarLaGrabacion()
                  comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                  router.push({ name: "PanelDeAudienciasPendientes" });
                } else {
                  this.sesionDeLaAudiencia.Marcadores.push(Object.assign("", this.marcador));
                  this.marcador = {
                    TipoMarcador: {
                      TipoMarcadorId: -1
                    },
                    Comentarios: null,
                    DuracionDelReceso: null,
                    Tiempo: null
                  };

                  const parametros = {
                    llave: "grabacion_TiposMarcador",
                    valor: this.marcador.TipoMarcador.TipoMarcadorId
                  }
                  this.$store.dispatch("A_Forseti_Catalogo_Establecer005TipoMarcador", parametros);
                }
              }
              comun.SeEstaCargandoInformacion(false);
            }
            ).catch(excepcion => {
              console.log(excepcion);
              comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
              comun.SeEstaCargandoInformacion(false);
            });
      },
      cambiarSala: function() {
        let parametros = {
          EsPrueba: this.enumeraciones.EsPrueba
        }
        let salas = [];

        axios.post(api.conexion + api.PJ.catalogos.C020Salas, parametros)
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              salas = comun.CreaElListadoParaBootboxPrompt(respuesta.data.Salas, enumeraciones.tiposDeSelect.Seleccione.Id, "SalaId");
              bootbox.prompt({
                title: "Mensaje del sistema",
                message: "Al momento de cambiar de sala, se creara una nueva sesión .<br />¿Realmente desea finalizar la grabación de la audiencia?<br /><br />",
                inputType: 'select',
                inputOptions: salas,
                buttons: {
                  cancel: {
                    label: '<i class="fa fa-times"></i>&nbsp;&nbsp;No'
                  },
                  confirm: {
                    label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Cambiar de sala'
                  }
                },
                callback: async (respuestaDelBootBox) => {
                  let _this = this; //
                  if(respuestaDelBootBox != null && respuestaDelBootBox != "") {
                    comun.SeEstaCargandoInformacion(true);

                    const parametros = {
                      SesionDeLaAudienciaId: this.SesionDeLaAudienciaId,
                      DuracionDeLaSesion: this.tiempo.Horas + ":" + this.tiempo.Minutos + ":" + this.tiempo.Segundos,
                      SalaId: respuestaDelBootBox,
                      EsPrueba: this.enumeraciones.EsPrueba
                    }

                    await this.ejecutaLaFinalizacionDeLaGrabacion()
                      .then(respuesta => {
                        //parametros.FechaDeFinalizacion = respuesta.data

                        axios.post(
                          api.conexion + api.Forseti.sistema.audiencias.audienciaspendientes.CambiarSalaYCrearUnaNuevaSesion,
                          parametros,
                          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
                          ).then(respuestaDelCambioDeSala => {
                            if(respuestaDelCambioDeSala.data.SiHayError){
                              console.log(respuestaDelCambioDeSala);
                              comun.mensajeDeAlerta(respuestaDelCambioDeSala.data.Error.Mensaje, null, null);
                              this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuestaDelCambioDeSala.data.Error.MensajeId });
                            } else {
                          
                              comun.mensajeDeAlerta(respuestaDelCambioDeSala.data.Satisfactorio, null, null);
                              router.push({ name: "PanelDeAudienciasPendientes" });
                            }
                            comun.SeEstaCargandoInformacion(false);
                          }
                          ).catch(excepcion => {
                            console.log(excepcion);
                            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                            comun.SeEstaCargandoInformacion(false);
                          });
                      })
                      .catch(exception => { console.log(exception) });
                      _this.EjecutaFinalizarTransmisionAudio(); 
                      _this.EjecutaFinalizarTransmisionEvidenciador();
                  }
                }
              });
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
          })
      },
      limpiarParaFinalizarLaGrabacion: function () {
        this.grabacionEnProceso = false;
        this.grabacionFinalizada = true;
        this.tiempo = {
          Horas: "00",
          Minutos: "00",
          Segundos: "00"
        };
        clearInterval(this.actualizarTiempoDeGrabacion);
      },
      finalizarGrabacion: function() {
        bootbox.confirm({
          title: "Mensaje del sistema",
          message: "Una vez finalizada la grabación de la audiencia, el video se guardará y no seguirá grabando.<br />¿Realmente desea finalizar la grabación de la audiencia?",
          buttons: {
            cancel: {
              label: '<i class="fa fa-times"></i>&nbsp;&nbsp;No'
            },
            confirm: {
              label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Si, finalizar la grabación'
            }
          },
          callback: async (respuestaDelBootBox) => {
            let _this = this;
            if(respuestaDelBootBox) {
              comun.SeEstaCargandoInformacion(true);

              let parametros = {
                SesionDeLaAudienciaId: this.SesionDeLaAudienciaId,
                DuracionDeLaSesion: this.tiempo.Horas + ":" + this.tiempo.Minutos + ":" + this.tiempo.Segundos,
                EsPrueba: this.enumeraciones.EsPrueba
              }

              await this.ejecutaLaFinalizacionDeLaGrabacion()
                .then(respuesta => {
                  if (respuesta != undefined) {
                    parametros.FechaDeFinalizacion = respuesta.data;
                    axios.post(
                      api.conexion + api.Forseti.sistema.audiencias.audienciaspendientes.FinalizarSesionDeLaAudiencia,
                      parametros,
                      comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
                      ).then(respuesta => {
                        if(respuesta.data.SiHayError){
                          console.log(respuesta);
                          comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                          this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
                          comun.SeEstaCargandoInformacion(false);
                        } else {
                          this.limpiarParaFinalizarLaGrabacion();
                          comun.SeEstaCargandoInformacion(false);
                          comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                          router.push({ name: "PanelDeAudienciasPendientes" });
                          //this.generarTokenYCrearZIP(respuesta.data.Satisfactorio);
                        }
                      }
                      ).catch(excepcion => {
                        console.log(excepcion);
                        comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                        comun.SeEstaCargandoInformacion(false);
                      });
                  }
                })
                .catch(exception => { console.log(exception) });
            _this.EjecutaFinalizarTransmisionEvidenciador();
            _this.EjecutaFinalizarTransmisionAudio();
            }
          }
        });
      },
      EjecutaTransmisionAudio: async function()
      {
        return axios.post(
          'http://' + this.sesionDeLaAudiencia.Sala.IP + this.sesionDeLaAudiencia.Sala.PuertoDeGrabacion + api.Forseti.sistema.audiencias.audienciaspendientes.EjecutarTransmisionAudio,
          { },
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
          ).then(respuesta => {
            if (respuesta.Error != undefined) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.Error, null, null);
              throw respuesta
            } else {
              // const audio_audiencia = this.$refs.audio_forseti;
              // audio_audiencia.src = this.sesionDeLaAudiencia.Sala.IPDeTransmision;
              // audio_audiencia.play();
              return respuesta;
            }
          }
          ).catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
            comun.SeEstaCargandoInformacion(false);
          });
      },
      EjecutaFinalizarTransmisionAudio: async function(){
        
        return axios.post(
          'http://' + this.sesionDeLaAudiencia.Sala.IP + this.sesionDeLaAudiencia.Sala.PuertoDeGrabacion + api.Forseti.sistema.audiencias.audienciaspendientes.TerminarTransmisionAudio,
          { },
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
          ).then(respuesta => {
            if (respuesta.Error != undefined) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.Error, null, null);
              throw respuesta
            } else {
              return respuesta;
            }
          }
          ).catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
            comun.SeEstaCargandoInformacion(false);
          });
      },
      EjecutaFinalizarTransmisionEvidenciador: async function(){
        
        return axios.post(
          'http://' + this.sesionDeLaAudiencia.Sala.IP + this.sesionDeLaAudiencia.Sala.PuertoDeGrabacion +  "/DetenerConversion",
          { },
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
          ).then(respuesta => {
            if (respuesta.Error != undefined) {
              comun.mensajeDeAlerta(respuesta.Error, null, null);
              throw respuesta
            } else {
              return respuesta;
            }
          }
          ).catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
            comun.SeEstaCargandoInformacion(false);
          });
      },
      /**
       * Función encargada de finalizar la grabación de la audiencia y preparar una nueva audiencia por algún cambio requerido para gabar la audiencia.
       */
      EjecutarCambioEnLaAudiencia: function(){
      bootbox.confirm({
          title: "Mensaje del sistema",
          message: "¿Desea hacer algún cambio en las cámaras de la audiencia? <br /> Una vez seleccionada esta opción la grabación de la audiencia finalizará y el video se guardará.",
          buttons: {
            cancel: {
              label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
            },
            confirm: {
              label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Realizar Cambio'
            }
          },
          callback: async (respuesta) => {
            if (respuesta) {
               
              await this.finalizarGrabacion2();
              //if(this.FinalGrabacion){
              comun.SeEstaCargandoInformacion(true);
        const parametros = {
          AudienciaId: this.AudienciaId,
          EsPrueba: this.enumeraciones.EsPrueba
        }
        axios.post(
          api.conexion + api.Forseti.sistema.audiencias.audienciasPorVerificar.AgregarSesion,
          parametros,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
        ).then(respuesta => {
          if (respuesta.data.SiHayError) {
            console.log(respuesta);
            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
          } else {
            comun.SeEstaCargandoInformacion(false);
            comun.mensajeDeAlerta("La sesión se ha agregado correctamente.<br />Se redirigió a 'Preparación de Sala'.", null, null);
           
          router.push({ name: "PreparacionDeSala", params: { SesionDeLaAudienciaId: respuesta.data.sesionId, AudienciaId:this.AudienciaId } });            
          }          
        }
        ).catch(excepcion => {
          console.log(excepcion);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
          comun.SeEstaCargandoInformacion(false);
          
        });
            
            //}
            }
          }
        });
      },
      /**
       * Función encargada de finalizar la grabación de la audiencia y guarda el video.
       */
      finalizarGrabacion2: async function() {
             let _this = this;
           // if(respuestaDelBootBox) {

              comun.SeEstaCargandoInformacion(true);

              let parametros = {
                SesionDeLaAudienciaId: this.SesionDeLaAudienciaId,
                DuracionDeLaSesion: this.tiempo.Horas + ":" + this.tiempo.Minutos + ":" + this.tiempo.Segundos,
                EsPrueba: this.enumeraciones.EsPrueba
              }

               await this.ejecutaLaFinalizacionDeLaGrabacion()
                .then(respuesta => {
                  if (respuesta != undefined) {
                    parametros.FechaDeFinalizacion = respuesta.data;
                    axios.post(
                      api.conexion + api.Forseti.sistema.audiencias.audienciaspendientes.FinalizarSesionDeLaAudiencia,
                      parametros,
                      comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
                      ).then(respuesta => {
                        if(respuesta.data.SiHayError){
                          console.log("Error Finalizar Grabacion: "+respuesta);
                          comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                          this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
                          comun.SeEstaCargandoInformacion(false);
                        } else {
                          this.limpiarParaFinalizarLaGrabacion();
                          comun.SeEstaCargandoInformacion(false);
                          comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                        }
                      }
                      ).catch(excepcion => {
                        console.log(excepcion);
                        comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                        comun.SeEstaCargandoInformacion(false);
                      });
                  }
                })
                .catch(exception => { console.log(exception) });
            await _this.EjecutaFinalizarTransmisionEvidenciador();
            await _this.EjecutaFinalizarTransmisionAudio();
      
      }
    //,
    //   generarTokenYCrearZIP: function (mensaje) {
    //     comun.SeEstaCargandoInformacion(true);

    //     const parametros = {
    //       AudienciaId: this.sesionDeLaAudiencia.Audiencia.AudienciaId,
    //       EsPrueba: this.enumeraciones.EsPrueba
    //     }

    //     axios.post(
    //       api.conexion + api.Forseti.sistema.audiencias.audienciaspendientes.GenerarTokenYCrearZipDeLaAudiencia,
    //       parametros,
    //       comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
    //     ).then(respuesta => {
    //       if (respuesta.data.SiHayError) {
    //         console.log(respuesta);
    //         comun.mensajeDeAlerta((mensaje != undefined && mensaje != null ? mensaje + "<br />" : "") + respuesta.data.Error.Mensaje, null, null);
    //         this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
    //         this.falloLaGeneracionDelZip = true;
    //       } else {
    //         this.falloLaGeneracionDelZip = false;
    //         comun.mensajeDeAlerta((mensaje != undefined && mensaje != null ? mensaje + "<br />" : "") + respuesta.data.Satisfactorio, null, null);
    //         router.push({ name: "PanelDeAudienciasPendientes" });
    //       }
    //       comun.SeEstaCargandoInformacion(false);
    //     }
    //     ).catch(excepcion => {
    //       console.log(excepcion);
    //       this.falloLaGeneracionDelZip = true;
    //       comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
    //       comun.SeEstaCargandoInformacion(false);
    //     });
    //   }
    },
    beforeRouteLeave (to, from, next) {
        if(this.grabacionEnProceso)
        {
          comun.mensajeDeAlerta('Actualmente existe una grabación de audiencia en curso, detenga el proceso para salir', null, null);
          next(false);
        }
        else
        {
          const audio_audiencia = this.$refs.audio_forseti;
          audio_audiencia.pause();
          audio_audiencia.src = '';
          this.EjecutaFinalizarTransmisionAudio();
          this.EjecutaFinalizarTransmisionEvidenciador();
          next()
        }
    }
  }
</script>

<style scoped>
  .padding-div-low {
    padding-top: 40px;
  }

  .grabador {
    width: 20px;
    height: 20px;
    margin-bottom: 0;
    border-radius: 50%;
    overflow: hidden;
    margin: 7.5px 3.5px;
    text-align: center;
  }

  .sin-grabar {
    background-color: #363638;
    color: whitesmoke;
  }

  .grabando {
    background-color: red;
    color: #363638;
  }

  .marcadores {
    height: 520px;
  }

    .marcadores ul {
      overflow-y: auto;
      height: 400px;
    }

      .marcadores ul li {
        background-color: #504f54;
        border: 1px solid rgba(0,0,0,.125);
      }
</style>




// WEBPACK FOOTER //
// src/components/Forseti/Audiencias/PanelDeAudienciasPendientes/Grabacion.vue